import {
  Flex, FormControl, FormLabel, Icon, Tooltip,
} from '@chakra-ui/react';
import { Controller } from 'react-hook-form';
import { CreatableSelect, chakraComponents } from 'chakra-react-select';
import { BsExclamationTriangle } from 'react-icons/bs';
import React from 'react';
import { useSelector } from 'react-redux';

const MultiValueLabel = (props) => {
  // eslint-disable-next-line react/destructuring-assignment
  if (props.data.validated) return <chakraComponents.MultiValueLabel {...props} />;
  return (
    <Tooltip label="Email validation pending">
      <Flex align="center">
        <Icon as={BsExclamationTriangle} mr="1" color="orange.600" />
        <chakraComponents.MultiValueLabel {...props} />
      </Flex>
    </Tooltip>
  );
};
const components = {
  DropdownIndicator: null,
  MultiValueLabel,
};

const isValidNewOption = (option) => {
  const emailRegex = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
  return emailRegex.test(option);
};

const SendTo = ({ control }) => {
  const user = useSelector((state) => state.account.user);

  const options = [{
    label: 'me', value: user.email, validated: true,
  }];

  return (
    <FormControl my="4">
      <FormLabel fontSize="sm">Send to:</FormLabel>
      <Controller
        control={control}
        name="sendto"
        render={({ field: { onChange, value, ref } }) => (
          <CreatableSelect
            value={value.map(({ mail, validated }) => ({ label: mail, value: mail, validated }))}
            components={components}
            noOptionsMessage={() => null}
            isMulti
            options={options}
            placeholder="Select some colors..."
            inputRef={ref}
            onChange={(val) => onChange(val.map((v) => ({ mail: v.value, validated: v.validated })))}
            isValidNewOption={isValidNewOption}
          />
        )}
      />
    </FormControl>
  );
};

export default SendTo;
